import { useCardContextValue } from '../state/CardContext';
import { getObjectLabelPropertyName } from '../utils/properties';
import DynamicWidthLabelInput from './DynamicWidthLabelInput';
import { jsx as _jsx } from "react/jsx-runtime";
const InlineEditableRecordLabel = ({
  isEditable = true
}) => {
  var _objectTypeDefinition, _objectTypeDefinition2;
  const {
    asyncData: {
      objectTypeDefinitionResult
    }
  } = useCardContextValue();
  if (!((_objectTypeDefinition = objectTypeDefinitionResult.data) !== null && _objectTypeDefinition !== void 0 && _objectTypeDefinition.objectTypeDefinition)) {
    return null;
  }
  const objectLabelPropertyName = getObjectLabelPropertyName((_objectTypeDefinition2 = objectTypeDefinitionResult.data) === null || _objectTypeDefinition2 === void 0 ? void 0 : _objectTypeDefinition2.objectTypeDefinition);
  return /*#__PURE__*/_jsx(DynamicWidthLabelInput, {
    propertyName: objectLabelPropertyName,
    isEditable: isEditable
  });
};
export default InlineEditableRecordLabel;